/**
 * One colour per KIND of section (2026-10-14, operator: songs with "intro 1 + 2, verse 1 2 + 3, solo, instrumental
 * etc"). A number or a space never changes the kind: VERSE 2 is verse green, PRE-CHORUS and Pre chorus are one.
 * Parts outside the usual five get their own colours rather than grey. Used by the song marking view, the Timeline
 * Launcher's strip, the Now playing Display, and (muted) Navigate's Timelines list: the one scheme everywhere a section
 * is coloured (2026-10-26, operator: "it should match"; the launcher had coloured by a hash of the name). A section's
 * own `color`, when set, wins wherever sections are drawn.
 */
const BASE: Record<string, string> = {
  intro: '#5aa2ff',
  verse: '#6fd08c',
  prechorus: '#f0c24b', build: '#f0c24b', buildup: '#f0c24b',
  chorus: '#ff6b8b', hook: '#ff6b8b', refrain: '#ff6b8b',
  drop: '#ff4d4d',
  bridge: '#b28cff',
  solo: '#ff9a3d',
  instrumental: '#c9a46b', interlude: '#c9a46b',
  breakdown: '#d46fff',
  outro: '#7f8cff', ending: '#7f8cff', end: '#7f8cff',
};

/** The kind of a section name: letters only, lower case ("PRE-CHORUS 2" -> "prechorus"). */
export function sectionKind(name: string): string {
  return name.toLowerCase().replace(/[^a-z]/g, '');
}

/** The kind a name is coloured as: the whole name's kind first ("PRE-CHORUS 2" -> "prechorus"), else the first word
 *  of it that names a kind ("GUITAR SOLO" -> "solo"); null when nothing matches. */
export function sectionKindKey(name: string): string | null {
  const whole = sectionKind(name);
  if (BASE[whole]) return whole;
  for (const w of name.toLowerCase().split(/[^a-z]+/)) if (w && BASE[w]) return w;
  return null;
}

/** The whole name's kind first ("PRE-CHORUS"), else the first word of it that names a kind ("GUITAR SOLO" is a solo,
 *  "BIG DROP" a drop); grey when nothing matches. */
export function sectionHue(name: string): string {
  const key = sectionKindKey(name);
  return key ? BASE[key]! : '#9aa0a6';
}

/** A section's colour as drawn: its own `color` when it has one (this file's rule: it wins wherever sections are
 *  drawn), else its kind's. Found 2026-10-27 (items-look-study): every caller passed only the name, so a section's own
 *  colour was never shown anywhere. */
export function sectionColour(section: { name: string; color?: string | undefined }): string {
  return section.color && section.color.trim() ? section.color : sectionHue(section.name);
}
